/**
 * Centralised route paths — import these instead of hard-coding strings.
 */
export const routes = {
  login: "/login",
  superadmin: "/superadmin",
  admin: "/admin",
  adminTournaments: "/admin/tournaments",
  adminTournamentNew: "/admin/tournaments/new",
  adminTournamentDetail: (id: number | string) => `/admin/tournaments/${id}`,
  adminTournamentSchedule: (id: number | string) =>
    `/admin/tournaments/${id}/schedule`,
  adminTournamentResults: (id: number | string) =>
    `/admin/tournaments/${id}/results`,
  adminTournamentRounds: (id: number | string) =>
    `/admin/tournaments/${id}/rounds`,
  adminTournamentStandings: (id: number | string) =>
    `/admin/tournaments/${id}/standings`,
  adminTournamentRules: (id: number | string) =>
    `/admin/tournaments/${id}/rules`,
  adminTournamentResultReports: (id: number | string) =>
    `/admin/tournaments/${id}/result-reports`,
  adminTournamentReferees: (id: number | string) =>
    `/admin/tournaments/${id}/referees`,
  referee: "/arbitro",
  adminPlayerProfile: (id: number | string) =>
    `/admin/players/${id}`,
  adminNotifications: "/admin/notifications",
  player: "/player",
  playerProfile: "/player/profile",
  playerGlobalProfile: (id: number | string) => `/player/profiles/${id}`,
  playerResultReports: "/player/result-reports",
  playerNotifications: "/player/notifications",
  playerTournamentRules: (id: number | string) =>
    `/player/tournaments/${id}/rules`,
  playerTournamentResults: (id: number | string) =>
    `/player/tournaments/${id}/results`,
} as const;

export type RouteKey = keyof typeof routes;
